import { AppLayout } from 'app/components/AppLayout';
import { selectIsAuthorized } from 'app/containers/Authorization/slice/selectors';
import { RouteConstants } from 'app/routes';
import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect, Route, RouteProps } from 'react-router-dom';

interface IProps extends RouteProps {
  component: any;
  withLayout?: boolean;
}

const PrivateRoute = ({
  component: Component,
  withLayout = true,
  ...rest
}: IProps) => {
  const isAuthorized = useSelector(selectIsAuthorized);

  if (!isAuthorized) return <Redirect to={RouteConstants.auth.login} />;
  const Layout = withLayout ? AppLayout : React.Fragment;
  return (
    <Route
      {...rest}
      render={props => (
        <Layout>
          <Component {...props} />
        </Layout>
      )}
    />
  );
};

export default PrivateRoute;
